
// 用于图片全部都加载完以后执行回调函数
// 第一个参数为所有图片路径的数组。
// 第二个参数为所有图片加载完成后的回调函数。
// 第三个参数为所有图片的前置路径，如果已经是完整路径，则不需要传此参数。
export function loadImageEnd(list, callback, basePath) {
    // 这个函数的使用方法来源参考的是 https://blog.csdn.net/Charissa2017/article/details/109692185
    if (!list || list.length === 0) return;
    if (basePath) list = list.map(item => basePath + item);
    let img = new Image();
    img.data = {
        list: list,
        callback: callback,
        resultList: [],
        num: 0
    }
    img.addEventListener("load", loadImgHandler);
    img.addEventListener("error", loadImgHandler);
    img.src = list[img.data.num];
}

function loadImgHandler(e) {
    let data = e.currentTarget.data;
    if (e.type !== 'error') {
        data.resultList.push(e.currentTarget.cloneNode(false));
    }
    data.num++;
    if (data.num > data.list.length - 1) {
        e.currentTarget.removeEventListener("load", loadImgHandler);
        if (data.callback) {
            data.callback(data.resultList);
        }
        data = null;
        return;
    }
    e.currentTarget.src = data.list[data.num];
}
